// 1-oct-2026 · Protección de envío opcional (3 €) en el carrito de Zendo.
// La casilla la pinta snippets/zendo-proteccion.liquid. Aquí se añade o quita el producto oculto y se avisa
// al carrito con el mismo evento que usa el tema (CartLinesUpdateEvent), para que el resumen y el total se
// actualicen sin recargar. Si algo falla, se recarga la página.
import { CartLinesUpdateEvent } from '@shopify/events';

const root = window.Shopify?.routes?.root || '/';
let busy = false;

function cartSectionIds() {
  const ids = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId);
  return [...new Set(ids.filter(Boolean))];
}

async function setProtection(variantId, quantity) {
  if (busy) return;
  busy = true;
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'update',
      context: 'cart',
      lines: [{ id: String(variantId), quantity }],
      promise: deferred.promise,
    })
  );

  try {
    const sections = cartSectionIds();
    const response = await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        updates: { [variantId]: quantity },
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'cart update failed');

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(data),
      detail: { sections: data.sections ?? undefined },
    });
    if (!sections.length || !data.sections) window.location.reload();
  } catch (error) {
    deferred.reject(error);
    window.location.reload();
  } finally {
    busy = false;
  }
}

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || !input.matches('.zendo-prot__input')) return;
  input.disabled = true;
  setProtection(input.dataset.zpVariant, input.checked ? 1 : 0);
});

// Si en el carrito solo queda la protección (se quitaron los demás productos), se quita también.
function removeOrphanProtection() {
  const orphan = document.querySelector('[data-zp-orphan]');
  if (orphan && !busy) setProtection(orphan.dataset.zpOrphan, 0);
}

new MutationObserver(removeOrphanProtection).observe(document.documentElement, { childList: true, subtree: true });
removeOrphanProtection();
